import { journeysSlice } from '../store/slice';

export const { setJourney, setJourneys } = journeysSlice.actions;
